module.exports = __webpack_public_path__ + "static/media/logo-img-only.d3d8ea4e.webp";